<template>
    <div>
        <div :key="option.id" v-for="option in options" class="overview__subitem show-control">
            <p class="overview__description">
                <span class="overview__partials">
                    Plocha <strong class="text--info" v-html="$options.filters.m2(option.area)"></strong>
                </span>
                <span class="overview__partials" v-if="option.price">
                    Cena <strong class="text--info">{{ option.price.withVat | numberFormat | currencySymbol }}</strong>
                </span>
            </p>
            <div class="overview__controls z1 m--t-1">
                <custom-button @click="update(option)" iconic>
                    <span icon edit></span>Upravit
                </custom-button>
                <custom-button @click="remove(option.id)" iconic class="visible-on-overview-hover">
                    <span icon remove></span>Odstranit
                </custom-button>
            </div>
        </div>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import UpdateAccessoryOptionDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/Option/UpdateAccessoryOptionDialog';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'AccessoryOptionList',
    components: {CustomButton},
    props:      {
        options:       {
            type:     Array,
            required: true,
        },
        accessoryType: {
            type:     Object,
            required: true,
        }
    },
    methods:    {
        update(accessory) {
            this.$modal.show(UpdateAccessoryOptionDialog, {
                accessory,
                accessoryTypeId: this.accessoryType.id
            }, defaultModalParameters());
        },
        remove(accessoryId) {
            this.$modal.show('dialog', {
                text:    'Opravdu chcete možnost odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/accessory/removeAccessory', accessoryId)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        },
    }
}
</script>
